import { KeyValuePipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ai as AiGen } from '@valvur/shared-grpc';
import {
  formatTimeAgo as formatTimeAgoUtil,
  getCategoryIcon,
  getCategoryLabelKey,
  getSeverityColor,
} from '../../constants/topic-category.constants';

@Component({
  selector: 'app-parent-ai-topics-panel',
  standalone: true,
  imports: [KeyValuePipe, TranslatePipe],
  templateUrl: './parent-ai-topics-panel.component.html',
  styleUrl: './parent-ai-topics-panel.component.scss',
})
export class ParentAiTopicsPanelComponent {
  #translate = inject(TranslateService);

  open = input(false);
  isLoadingTopics = input(false);
  topicCounts = input<Record<string, number>>({});
  filteredTopics = input<AiGen.TopicThreadDto[]>([]);
  selectedTopicId = input<string | null>(null);

  close = output<void>();
  topicSelected = output<AiGen.TopicThreadDto>();
  newConversation = output<void>();

  protected getCategoryLabelKey = getCategoryLabelKey;
  protected getCategoryIcon = getCategoryIcon;
  protected getSeverityColor = getSeverityColor;

  protected formatTimeAgo(ts: number): string {
    return formatTimeAgoUtil(ts, (key, params) =>
      this.#translate.instant(key, params),
    );
  }
}
